// components/Divider.tsx
import React from "react";

type DividerProps = {
  /** Center text (defaults to "Continue") */
  children?: React.ReactNode;
  /** Goes on the parent wrapper so you can control col-span, spacing, etc. */
  className?: string;
  /** Optional: customize the line appearance */
  lineClassName?: string;
  /** Optional: customize the text appearance */
  textClassName?: string;
};

export const Divider: React.FC<DividerProps> = ({
  children = "Continue",
  className = "",
  lineClassName = "",
  textClassName = "",
}) => {
  return (
    <div
      className={`flex items-center ${className}`}
      role="separator"
      aria-label={
        typeof children === "string" ? (children as string) : "Divider"
      }
    >
      <span className={`h-px flex-1 bg-gray-200 ${lineClassName}`} />
      <span className={`mx-3 text-sm text-gray-500 select-none ${textClassName}`}>
        {children}
      </span>
      <span className={`h-px flex-1 bg-gray-200 ${lineClassName}`} />
    </div>
  );
};

export default Divider;